import { AuthenticationResult, EventMessage, EventType } from '@azure/msal-browser';
import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';

import { App, AppShellForDemo } from './app';
import { pca } from './config/msal';

import './styles.css';
import './lib/i18n';

pca.initialize()
	.then(() => {
		return pca.handleRedirectPromise();
	})
	.then(() => {
		const accounts = pca.getAllAccounts();

		if (!pca.getActiveAccount() && accounts[0]) {
			pca.setActiveAccount(accounts[0]);
		}

		pca.addEventCallback((event: EventMessage) => {
			if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
				const payload = event.payload as AuthenticationResult;
				const account = payload.account;

				pca.setActiveAccount(account);
			}
		});

		ReactDOM.createRoot(document.body).render(
			<StrictMode>
				<AppShellForDemo>
					<App />
				</AppShellForDemo>
			</StrictMode>,
		);
	})
	.catch((error) => console.error(error));
